import { Roles } from '../constants/roles';

export const mockUsers = [
  {
    id: 'borrower-1',
    email: 'borrower@example.com',
    password: 'password',
    firstName: 'Alex',
    lastName: 'Borrower',
    name: 'Alex Borrower',
    role: Roles.Borrower,
    loginType: 'Both',
  },
];
